import React from "react";
import PropTypes from "prop-types";
import { RichText } from "@learningblocks/shared-components/lib/RichText";

/**
 * Check if the text contains mathematical notation that requires MathJax formatting
 * @param {string|object} label - The label text or object
 * @returns {boolean} True if mathematical notation is detected
 */
function hasMathematicalNotation(label) {
  let text = "";

  if (typeof label === "string") {
    text = label;
  } else if (label && typeof label === "object" && label.defaultMessage) {
    text = label.defaultMessage;
  } else if (label && typeof label === "object" && label.id) {
    text = label.id;
  }

  if (!text) return false;

  // Check for common mathematical notation patterns
  // LaTeX inline math: $...$ or \(...\)
  if (text.includes("$") || text.includes("\\(") || text.includes("\\[")) {
    return true;
  }

  // Check for LaTeX commands
  if (/\\[a-zA-Z]+/.test(text)) {
    return true;
  }

  // Check for common subscript/superscript patterns in HTML
  if (/<sub>|<sup>|<math>/.test(text)) {
    return true;
  }

  return false;
}

/**
 * The label Components for Question Options.
 */
export function Label(props) {
  const richTextProps =
    typeof props.label === "string"
      ? { value: props.label }
      : { ...props.label };

  const hasEquation = hasMathematicalNotation(props.label);

  return (
    /* eslint-disable-next-line jsx-a11y/label-has-associated-control */
    <label className={props.className} htmlFor={props.id}>
      <div className={props.className}>
        <div style={{ whiteSpace: "pre-line" }}>
          <RichText {...richTextProps} equation={hasEquation}/>
        </div>
      </div>
    </label>
  );
}

Label.propTypes = {
  /**
   * className to be set for label element
   */
  className: PropTypes.string,
  /**
   * Text to be displayed
   */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  /**
   * id for label
   */
  id: PropTypes.number,
};

Label.defaultProps = {
  className: "",
  label: "",
  id: 0,
};
